// UI/Progress/pageProgress.jsx
import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import NProgress from "nprogress"
import "CSS/nprogress.css"

NProgress.configure({ showSpinner: false, speed: 400, minimum: 0.1 })

const PageProgress = () => {
    const location = useLocation()

    useEffect(() => {
        NProgress.start()
        return () => NProgress.done()
    }, [location.pathname])

    return null
}

export default PageProgress